import { createTheme, responsiveFontSizes } from "@mui/material/styles";
import { itIT } from "@mui/material/locale";
import "../fontStyle.css";

let theme = createTheme(
    {
        palette: {
            mode: "light",
            primary: {
                main: "#1cbfd7",
                light: "#5ed7e8",
                dark: "#1494a3",
                contrastText: "#ffffff",
            },
            secondary: {
                main: "#cddbe0",
                light: "#e2edf1",
                dark: "#a9b7bd",
                contrastText: "#111111",
            },
            background: {
                default: "#f9fcfd",
                paper: "#ffffff",
            },
            text: {
                primary: "#111111",
                secondary: "#4a4a4a",
            },
            error: {
                main: "#e53935",
            },
            warning: {
                main: "#fbc02d",
            },
            info: {
                main: "#0288d1",
            },
            success: {
                main: "#43a047",
            },
        },
        typography: {
            fontFamily: '"Titillium Web", "Rajdhani", "Roboto", "Helvetica", "Arial", sans-serif',
            fontSize: 14,
            h1: {
                fontSize: "2.2rem",
                fontWeight: 700,
            },
            h2: {
                fontSize: "1.8rem",
                fontWeight: 600,
            },
            h3: {
                fontSize: "1.4rem",
                fontWeight: 600,
            },
            button: {
                textTransform: "uppercase",
                fontWeight: 600,
            },
        },
        components: {
            MuiButton: {
                styleOverrides: {
                    root: {
                        borderRadius: 8,
                    },
                    containedPrimary: {
                        backgroundColor: "#1cbfd7",
                        color: "#ffffff",
                        "&:hover": {
                            backgroundColor: "#1494a3",
                        },
                    },
                },
            },
            MuiPaper: {
                styleOverrides: {
                    rounded: {
                        borderRadius: 12,
                    },
                },
            },
            MuiChip: {
                styleOverrides: {
                    root: {
                        fontWeight: 500,
                        fontSize: "0.75rem",
                    },
                },
            },
        },
    },
    itIT
);

theme = responsiveFontSizes(theme);

export default theme;
